import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import EyeIcon from "../../../imgs/eye-icon.svg";
import EditIcon from "../../../imgs/edit-icon.svg";
import ArrowIcon from "../../../imgs/arrow-down-icon.svg";
import PdfIcon from "../../../imgs/pdf-icon.svg"; // Import de l'icône PDF
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import * as fetch from "./../../../network/fetch";
import State from "../State";
import ReactJson from "react-json-view";
import TutorialPopup from "../../../components/TutorialPopup/TutorialPopup";

const Step2Form = () => {
  const wait = (ms) => {
    console.log("=== `Waiting ${ms}ms` === Step2Form.js === key: 141369 ===");
    console.dir(`Waiting ${ms}ms`, { depth: null, colors: true });
    console.log("=================================");
    return new Promise((resolve) => setTimeout(resolve, ms));
  };

  const navigate = useNavigate();
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [documents, setDocuments] = useState([]); // State to store documents
  const [documentChanges, setDocumentChanges] = useState([]);
  const [editFormData, setEditFormData] = useState({
    input1: "",
    field2: "",
    input3: "",
    file: null,
    docId: null,
  });

  const [initialEditFormData, setInitialEditFormData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [metadata, setMetadata] = useState();

  const total_steps = 2;
  const current_step = 2;

  useEffect(() => {
    // Load documents from State when the component mounts
    console.log("=== State.documents === Step2Form.js === key: 337736 ===");
    console.dir(State.documents, { depth: null, colors: true });
    console.log("=================================");
    setDocuments(State.documents);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate("/notarization/step3", { replace: true });
  };

  const handleViewClick = (rowData) => {
    console.log("=== rowData === Step2Form.js === key: 303064 ===");
    console.dir(rowData, { depth: null, colors: true });
    console.log("=================================");
    handleDownloadChanges(rowData.docId);
    setIsLoading(true);
    setSelectedData(rowData);
    setShowViewModal(true);
  };

  const handleEditClick = async (document, index) => {
    setIsLoading(true);
    let initialData = {
      input1: document.documentName,
      field2: document.documentType || "",
      input3: document.documentDescription || "",
      file: null,
      docId: document.id,
      document,
      index,
    };
    setShowEditModal(true);
    await wait(1500);
    let response = await fetch.fetchDocumentChanges(document.id);

    if (response.success) {
      console.log("=== response.data === Step2Form.js === key: 170257 ===");
      console.dir(response.data, { depth: null, colors: true });
      console.log("=================================");
      if (response.data?.documentChanges?.length) {
        let len = response.data.documentChanges.length;
        let lastChange = response.data.documentChanges[len - 1];
        try {
          let parsedChange = JSON.parse(lastChange.change);
          initialData.input1 = parsedChange.docName || document.documentName;
          initialData.field2 = parsedChange.type || document.documentType;
          initialData.input3 =
            parsedChange.description || document.documentDescription;
        } catch (e) {
          //console.error('Erreur lors du parsing du dernier changement', e);
        }
      }
    }

    setIsLoading(false);

    setEditFormData(initialData);
    setInitialEditFormData(initialData);
    /*!editFormData.input1
      ? setEditFormData(initialData)
      : setEditFormData({
          ...editFormData,
          file: null,
          docId: document.id,
          document,
          index,
        });
    !editFormData.input1
      ? setInitialEditFormData(initialData)
      : setInitialEditFormData({
          ...editFormData,
          file: null,
          docId: document.id,
          document,
          index,
        });*/
  };

  const handleCloseViewModal = () => {
    setIsLoading(false);
    setShowViewModal(false);
    setDocumentChanges([]);
  };
  const handleCloseEditModal = () => {
    setIsLoading(false);
    setShowEditModal(false);
    setDocumentChanges([]);
  };

  /** ---------------------- cmt ----------------------
  * const handleDownload = async (docId) => {
    try {
      const response = await fetch.downloadNotarizedDocument(docId);

      if (response.success) {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);
        window.open(url, "_blank");
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
      } else {
        console.error("Erreur lors du téléchargement", response.error);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération du document", error);
    }
  };
  *--------------------------------------------------*/

  const handleDownload = async (docId) => {
    try {
      const response = await fetch.downloadNotarizedDocument(docId);
  
      if (response.success) {
        // Récupérer le type de contenu depuis les en-têtes de réponse
        let contentType = response.headers['content-type'] || 'application/octet-stream';
        contentType = contentType.split(';')[0]; // Supprimer les paramètres éventuels du type MIME
  
        // Le blob est déjà disponible dans response.data
        const blob = response.data;
  
        // Créer une URL pour le Blob
        const url = window.URL.createObjectURL(blob);
  
        // Ouvrir ou télécharger le fichier en fonction du type MIME
        if (contentType === 'application/pdf') {
          window.open(url, '_blank');
        } else {
          const a = document.createElement('a');
          a.href = url;
          // Utiliser une fonction pour obtenir l'extension du fichier à partir du type MIME
          a.download = `document.${getExtensionFromMimeType(contentType)}`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
  
        // Révoquer l'URL Blob après un certain temps pour libérer de la mémoire
        setTimeout(() => window.URL.revokeObjectURL(url), 1000);
      } else {
        console.error("Erreur lors du téléchargement", response.error);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération du document", error);
    }
  };
  
  // Fonction utilitaire pour obtenir l'extension de fichier à partir du type MIME
  const getExtensionFromMimeType = (mimeType) => {
    const mimeTypes = {
      'application/pdf': 'pdf',
      'image/jpeg': 'jpg',
      'image/png': 'png',
      'application/msword': 'doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
      // Ajoutez d'autres types MIME si nécessaire
    };
    return mimeTypes[mimeType] || 'bin';
  };
  

  const handleDownloadChanges = async (docId) => {
    let changes = [];
    try {
      const response = await fetch.fetchDocumentChanges(docId);

      console.log("=== response === Step2Form.js === key: 647765 ===");
      console.dir(response, { depth: null, colors: true });
      console.log("=================================");

      if (response.success) {
        changes = response.data?.documentChanges?.length
          ? [...response.data?.documentChanges]
          : [];
      }
    } catch (error) {
      console.error("Erreur lors de la récupération du document", error);
    }

    console.log("=== changes === Step2Form.js === key: 679548 ===");
    console.dir(changes, { depth: null, colors: true });
    console.log("=================================");

    const parsedChanges = changes.map((item) => {
      let parsedChange;
      try {
        // Tente de parser la chaîne de caractères
        parsedChange = JSON.parse(item.change);
      } catch (e) {
        // Si une erreur survient, ce n'est pas un JSON valide, donc garde la valeur d'origine
        parsedChange = item.change;
      }

      // Retourne un nouvel objet avec le changement éventuellement parsé
      return {
        ...item,
        change: parsedChange,
      };
    });

    console.log("=== parsedChanges === Step2Form.js === key: 005566 ===");
    console.dir(parsedChanges, { depth: null, colors: true });
    console.log("=================================");

    setDocumentChanges(parsedChanges || []);
    setIsLoading(false);

    return parsedChanges || [];
  };

  const onSetMetadata = async (e) => {
    setMetadata([]);
    e.preventDefault();
    let data = [];
    for (let i = 0; i < documents.length; i++) {
      const doc = documents[i];
      const response = await fetch.fetchDocumentMetadata(doc.id);
      if (response.success) {
        let response2 = await fetch.fetchDocumentChanges(doc.id);
        if (response2.success) {
          console.log(
            "=== response2.data === Step2Form.js === key: 502324 ==="
          );
          console.dir(response2.data, { depth: null, colors: true });
          console.log("=================================");
          const parsedChanges = response2.data.documentChanges.map((item) => {
            let parsedChange;
            try {
              // Tente de parser la chaîne de caractères
              parsedChange = JSON.parse(item.change);
            } catch (e) {
              // Si une erreur survient, ce n'est pas un JSON valide, donc garde la valeur d'origine
              parsedChange = item.change;
            }

            // Retourne un nouvel objet avec le changement éventuellement parsé
            return {
              ...item,
              change: parsedChange,
            };
          });
          data.push({
            metadata: response.data,
            documentChanges: [...parsedChanges],
          });
        }
      }
    }
    setMetadata(data);
  };

  const handleEditFileSelect = () => {
    document.getElementById("edit-file-input").click();
  };

  const handleEditChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "file") {
      setEditFormData({
        ...editFormData,
        file: files[0],
      });
    } else {
      setEditFormData({
        ...editFormData,
        [name]: value,
      });
    }
  };

  const isEditFormValid = () => {
    // Vérifier si un fichier a été sélectionné
    if (!editFormData.file) {
      return false;
    }

    let fieldsChanged = false;

    // Vérifier si au moins un champ a été modifié
    fieldsChanged = editFormData.input3 !== initialEditFormData.input3 || editFormData.field2 !== initialEditFormData.field2 || editFormData.input1 !== initialEditFormData.input1 || editFormData.file;

    return fieldsChanged;
  };

  const handleEditSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();

    const formData = new FormData();
    formData.append("docId", editFormData.docId);
    formData.append("documentName", editFormData.input1);
    formData.append("documentType", editFormData.field2);
    formData.append(
      "change",
      JSON.stringify({
        docName: editFormData.input1,
        description: editFormData.input3,
        type: editFormData.field2,
      })
    );
    formData.append("timestamp", new Date().toISOString());
    formData.append("user", "Author Name");
    if (editFormData.file) {
      formData.append("file", editFormData.file);
    }

    try {
      const response = await fetch.trackDocumentChanges(
        editFormData.docId,
        formData
      );
      if (response.success) {
        console.log("=== response === Step2Form.js === key: 288941 ===");
        console.dir(response, { depth: null, colors: true });
        console.log("=================================");

        await wait(3000);

        const response2 = await fetch.fetchDocumentChanges(editFormData.docId);
        if (response2.success) {
          console.log("=== response2 === Step2Form.js === key: 723289 ===");
          console.dir(response2, { depth: null, colors: true });
          console.log("=================================");
        } else {
          console.error(
            "Erreur lors de la récupération de l'historique des changements",
            response2.error
          );
        }
      } else {
        console.error(
          "Erreur lors de l'enregistrement des changements",
          response.error
        );
      }
    } catch (error) {
      console.error("Erreur dans handleEditSubmit", error);
    }
    setIsLoading(false);
    handleCloseEditModal();
  };

  const solutionNextStep = (e) => {
    e.preventDefault();
    navigate("/notarisation/step2", {
      replace: true,
    });
    return;
  };

  const handleNextTutorialStep = (e) => {
    e.preventDefault();
    if (tutorialStep < tutorialSteps.length - 1) {
      setTutorialStep(tutorialStep + 1);
    } else {
      setTutorialStep(-1); // Toutes les étapes sont terminées
    }
  };

  const handleCloseTutorial = (e) => {
    e.preventDefault();
    setTutorialStep(-1);
  };

  const [tutorialStep, setTutorialStep] = useState(0);
  const [tutorialSteps, setTutorialSteps] = useState([
    {
      content: (
        <>
          <p className="tutorial-title">Modifier les données (1/2)</p>{" "}
          <p>
            Maintenant, imaginez que vous avez fait une erreur et vous cliquez
            sur l’icône modifier pour changer le nom du document..
          </p>
        </>
      ),
      showArrow: "right",
      position: { top: "150px", left: "47%", width: "500px" },
    },
    {
      content: (
        <>
          <p className="tutorial-title">Visualier l’historique (2/2)</p>{" "}
          <p>
            Vous allez modifier le nom du document et vous pourrez cliquer sur
            le bouton “voir”afin d’afficher l’historique. Votre modification
            sera notariée après sauvegarde de votre modification.
          </p>
        </>
      ),
      closeLabel: "hidden",
      showArrow: "right",
      position: { top: "150px", left: "43%", width: "500px" },
    },
    // Ajoutez plus d'étapes si nécessaire
  ]);

  return (
    <>
      <form onSubmit={handleSubmit} className="container form-2">
        <div className="form-heading-wrapper">
          <ProgressBar total_steps={total_steps} current_step={current_step} />
        </div>

        {/* Affichage du popup tutoriel */}
        {tutorialStep >= 0 && (
          <TutorialPopup
            content={tutorialSteps[tutorialStep].content}
            position={tutorialSteps[tutorialStep].position}
            isVisible={tutorialStep >= 0}
            onNext={
              tutorialSteps[tutorialStep].handleNextTutorialStep ||
              handleNextTutorialStep
            }
            onClose={handleCloseTutorial}
            showArrow={tutorialSteps[tutorialStep].showArrow || false}
            tmpNextLabel={tutorialSteps[tutorialStep].nextLabel}
            tmpCloseLabel={tutorialSteps[tutorialStep].closeLabel}
          />
        )}

        <div className="fiels-main-wrapper pb-5">
          {/* <div className="action-btn">
            <Link to="/" className="btn btn-primary">
              Voir les données sur la blockchain
            </Link>
          </div> */}

          <div className="custom-table">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Nom du document</th>
                  <th>Date de création</th>
                  <th>Auteur</th>
                  <th>Description</th>
                  <th>Id du document</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {documents.length > 0 ? (
                  documents.map((doc, index) => (
                    <tr key={index}>
                      <td>{doc.documentName}</td>
                      <td>{doc.documentDate}</td>
                      <td>{doc.documentAuthor}</td>
                      <td>{doc.documentDescription}</td>
                      <td>{doc.id}</td>
                      <td>
                        <Button
                          variant="link"
                          onClick={() =>
                            handleViewClick({
                              log: doc.documentName,
                              dateTime: doc.documentDate,
                              description: doc.documentDescription,
                              user: doc.documentAuthor,
                              docId: doc.id,
                              fileCid: doc.ipfs_cid,
                            })
                          }
                        >
                          <img src={EyeIcon} alt="View" />
                        </Button>
                        <Button
                          variant="link"
                          onClick={() => handleEditClick(doc, index)}
                        >
                          <img src={EditIcon} alt="Edit" />
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6">Aucun document trouvé.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="btn-wrapper">
            {!metadata && (
              <button className="btn btn-primary" onClick={onSetMetadata}>
                Voir les données brutes
              </button>
            )}
            {metadata && (
              <button
                className="btn btn-primary"
                onClick={() => {
                  setMetadata(null);
                }}
              >
                Masquer les données brutes
              </button>
            )}
          </div>

          {metadata && (
            <div className="metadata-display">
              <h4>Données des documents:</h4>
              <ReactJson
                src={metadata}
                displayRoot={false} // Pour masquer l'objet racine (facultatif)
                theme="monokai" // Vous pouvez changer ce thème selon vos préférences
                collapsed={false} // Pour s'assurer que le JSON est entièrement déployé
                displayDataTypes={false} // Pour masquer les types de données (facultatif)
                displayObjectSize={false} // Pour masquer la taille de l'objet (facultatif)
                enableClipboard={false} // Pour désactiver le bouton de copie (facultatif)
              />
            </div>
          )}
        </div>
      </form>

      {/* View Modal */}
      <Modal
        show={showViewModal}
        onHide={handleCloseViewModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Historique</Modal.Title>
        </Modal.Header>
        {!isLoading && (
          <Modal.Body>
            {selectedData ? (
              <div className="custom-table">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Nom du document</th>
                      <th>Date et heure</th>
                      <th>Description</th>
                      <th>Utilisateur</th>
                      <th>Fichier</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{selectedData.log}</td>
                      <td>{selectedData.dateTime}</td>
                      <td>{selectedData.description}</td>
                      <td>{selectedData.user}</td>
                      <td style={{ padding: "5px 0" }}>
                        <Button
                          variant="primary"
                          style={{ margin: 0 }}
                          onClick={() => handleDownload(selectedData.fileCid)}
                        >
                          Télécharger
                        </Button>
                      </td>
                    </tr>

                    {documentChanges.length > 0 &&
                      documentChanges.map((doc, index) => (
                        <tr key={index + "b"}>
                          <td>{doc.change.docName}</td>
                          <td>
                            {
                              new Date(doc.timestamp * 1000)
                                .toISOString()
                                .split("T")[0]
                            }
                          </td>
                          <td>{doc.change.description}</td>
                          <td>{selectedData.user}</td>
                          <td style={{ padding: "5px 0" }}>
                            <Button
                              variant="primary"
                              style={{ margin: 0 }}
                              onClick={() => handleDownload(doc.fileCid)}
                            >
                              Télécharger
                            </Button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p>Aucune donnée sélectionnée.</p>
            )}
          </Modal.Body>
        )}
        {isLoading && (
          <div className="spinner-wrapper">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseViewModal}>
            Fermer
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Modal */}
      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton className="pt-5">
          <Modal.Title>Modifier le document</Modal.Title>
        </Modal.Header>
        {!isLoading && (
          <Modal.Body>
            <form onSubmit={handleEditSubmit}>
              <div className="fields-main">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-field mb-3">
                      <label htmlFor="input1" className="form-label">
                        Nom du document
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="input1"
                        name="input1"
                        value={editFormData.input1}
                        onChange={handleEditChange}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-field mb-3">
                      <label htmlFor="field2" className="form-label">
                        Type
                      </label>
                      <select
                        className="form-control"
                        id="field2"
                        name="field2"
                        value={editFormData.field2}
                        onChange={handleEditChange}
                      >
                        <option value="" disabled></option>
                        <option value="option1">Option 1</option>
                        <option value="option2">Option 2</option>
                        <option value="option3">Option 3</option>
                      </select>

                      <span className="arrow-icon">
                        <img src={ArrowIcon} alt="Arrow Icon"></img>
                      </span>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-field mb-4">
                      <label htmlFor="input3" className="form-label">
                        Description
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="input3"
                        name="input3"
                        value={editFormData.input3}
                        onChange={handleEditChange}
                        required
                      />
                    </div>
                  </div>
                  {/* Champ de sélection de fichier */}
                  <div className="col-md-12">
                    <div className="form-field file-wrapper mb-3">
                      <label htmlFor="attachedFiles" className="form-label">
                        Ajouter un fichier
                      </label>
                      <br />
                      <button
                        type="button"
                        className="btn btn-primary choose-file"
                        onClick={handleEditFileSelect}
                      >
                        Ajouter
                      </button>
                      <input
                        type="file"
                        id="edit-file-input"
                        name="file"
                        style={{ display: "none" }}
                        onChange={handleEditChange}
                      />
                    </div>
                    {/* Aperçu du fichier sélectionné */}
                    {editFormData.file && (
                      <div className="file-preview">
                        <div className="file-preview-item">
                          <span className="pdf-icon">
                            <img src={PdfIcon} alt="Icône PDF"></img>
                          </span>
                          <span className="white-text">
                            {editFormData.file.name}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="col-md-12 text-right pb-5">
                    {!isLoading && (
                      <>
                        <Button
                          disabled={!isEditFormValid()}
                          variant="primary"
                          type="submit"
                          className="ms-2"
                        >
                          Sauvegarder
                        </Button>{" "}
                        <Button
                          variant="secondary"
                          onClick={handleCloseEditModal}
                        >
                          Fermer
                        </Button>
                      </>
                    )}
                    {isLoading && (
                      <div className="spinner-wrapper">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </form>
          </Modal.Body>
        )}
        {isLoading && (
          <div className="spinner-wrapper" style={{ "margin-bottom": "50px" }}>
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

export default Step2Form;
